import _ from "lodash";
import Utils from "../helpers/Utils";

export const handleAddress = (business, maxLength = 80) => {
    let address = "";

    if (!_.isNil(business) && !_.isNil(business.address)) {
        const fullAddress = business.address;

        if (fullAddress.street && !_.isEmpty(fullAddress.street)) {
            address = `${Utils.capitalize(fullAddress.street)}`;
        }

        if (fullAddress.number && !_.isEmpty(fullAddress.number)) {
            address = !_.isEmpty(address) ? `${address}, ${fullAddress.number}` : `${fullAddress.number}`;
        }

        if (fullAddress.unit && !_.isEmpty(fullAddress.unit) && fullAddress.unit !== "Sem complemento") {
            address = !_.isEmpty(address) ? `${address}, ${fullAddress.unit}` : `${fullAddress.unit}`;
        }

        if (fullAddress.neighborhood && !_.isEmpty(fullAddress.neighborhood)) {
            address = !_.isEmpty(address)
                ? `${address} - ${Utils.capitalize(fullAddress.neighborhood)}`
                : `${Utils.capitalize(fullAddress.neighborhood)}`;
        }

        if (fullAddress.city && !_.isEmpty(fullAddress.city)) {
            address = !_.isEmpty(address)
                ? `${address}, ${Utils.capitalize(fullAddress.city)}`
                : `${Utils.capitalize(fullAddress.city)}`;
        }

        if (fullAddress.state && !_.isEmpty(fullAddress.state)) {
            address = !_.isEmpty(address)
                ? `${address} - ${Utils.capitalize(fullAddress.state)}`
                : `${Utils.capitalize(fullAddress.state)}`;
        }

        if (address.length > maxLength) {
            address = address.substring(0, maxLength) + "...";
        }
    }

    return address;
};

export  const getInitials = (businessName) => {
    if (!businessName) return "";
    return businessName
        .split(" ")
        .map((word) => word.charAt(0))
        .join("")
        .toUpperCase()
        .substring(0, 2);
};

export const getAvatarFontSize = (businessName) => {
    if (!businessName) return "clamp(30px, 2vw, 32px)";
    
    const initials = getInitials(businessName);
    const charCount = initials.length;
    
    if (charCount === 1) {
        return "clamp(40px, 3vw, 42px)";
    } else if (charCount === 2) {
        return "clamp(36px, 2.5vw, 40px)";
    } 
};

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    

    const cleanNumber = phoneNumber.replace(/\D/g, "");
    
    const country = Utils.ddis.find(country => {
        const ddiDigits = country.ddi.replace(/\D/g, "");
        return cleanNumber.startsWith(ddiDigits);
    });
    
    if (!country) {
        if (cleanNumber.length >= 10) {
            return `+${cleanNumber}`;
        }
        return phoneNumber;
    }
    
    const ddiDigits = country.ddi.replace(/\D/g, "");
    let numberWithoutDdi = cleanNumber.substring(ddiDigits.length);
    
    if (country.phoneExtraPrefixNumber && typeof country.phonePositionNumberExtraPrefix === "number") {
        const prefixDigit = String(country.phoneExtraPrefixNumber);
        const position = country.phonePositionNumberExtraPrefix;
        
        const existingPrefix = numberWithoutDdi.slice(position, position + prefixDigit.length);
        if (existingPrefix !== prefixDigit && numberWithoutDdi.length > position) {
            numberWithoutDdi = numberWithoutDdi.slice(0, position) + prefixDigit + numberWithoutDdi.slice(position);
        }
    }
    
    const mask = country.pattern.mask;
    let formattedNumber = "";
    let numIndex = 0;
    
    for (let i = 0; i < mask.length && numIndex < numberWithoutDdi.length; i++) {
        const currentChar = mask[i];
        if ([" ", "-", "(", ")"].includes(currentChar)) {
            formattedNumber += currentChar;
        } else if (currentChar === "X") {
            formattedNumber += numberWithoutDdi[numIndex] || "";
            numIndex++;
        }
    }
    
    return `${country.ddi} ${formattedNumber}`;
};

export const getCountryCode = (phoneNumber) => {
    if (!phoneNumber) return "";
    
    const cleanNumber = phoneNumber.replace(/\D/g, "");
    
    const country = Utils.ddis.find(country => {
        const ddiDigits = country.ddi.replace(/\D/g, "");
        return cleanNumber.startsWith(ddiDigits);
    });
    
    if (country) {
        return country.ddi.replace(/\D/g, "");
    }
    
    return "";
};

export const getCountryInfo = (phoneNumber) => {
    if (!phoneNumber) return null;
    
    const cleanNumber = phoneNumber.replace(/\D/g, "");
    
    const country = Utils.ddis.find(country => {
        const ddiDigits = country.ddi.replace(/\D/g, "");
        return cleanNumber.startsWith(ddiDigits);
    });
    
    return country || null;
};

export const paymentTypesValidation = (paymentType, t) => {
    if (!t) {
        const fallback = {
            'cash': 'Dinheiro',
            'credit': 'Cartão de crédito',
            'creditprit': 'Cartão de crédito',
            'debit': 'Cartão de débito',
            'debitprit': 'Cartão de débito',
            'pixprit': 'Pix',
            'mbwayprit': 'Mb-Way',
            'undefined': 'Prit Pay',
            'pix': 'Pix',
        };
        return fallback[paymentType] || "";
    }

    switch (paymentType) {
        case 'cash':
            return t('Cash');
        case 'credit':
            return t('Credit card');
        case 'creditprit':
            return t('Credit card');
        case 'debit':
            return t('Debit card');
        case 'debitprit':
            return t('Debit card');
        case 'pixprit':
            return t('Pix');
        case 'mbwayprit':
            return t('Mb-Way');
        case 'undefined':
            return t('Prit Pay');
        case 'pix':
            return t('Pix');
        default:
            return "";
    }
  };

  export const redirectToWhatsapp = (phoneNumber, textOption) => {
    if (!phoneNumber) return;
    const linkBase = "https://wa.me/";
    const cleanNumber = phoneNumber.replace(/\D/g, "");

    let url = `${linkBase}${cleanNumber}?text=${encodeURIComponent(textOption)}`;

    window.open(url, "_blank");
  }

  export const callBusinessPhone = (phoneNumber) => {
    if (!phoneNumber) return;
    const cleanNumber = phoneNumber.replace(/\D/g, "");
    const tellLink = `tel:${cleanNumber}`;
    window.open(tellLink, "_self");
  }

  export const sendEmailToBusiness = (email) => {
    if (!email) return;
    const mailToLink = `mailto:${email}`;
    window.open(mailToLink, "_self");
  }

/**
 * Verifica se a URL contém um código de cor hexadecimal.
 * Usado para identificar URLs que contêm cores customizadas (ex: color_6A4C93.svg)
 * @param {string} url - URL a ser verificada
 * @returns {boolean} - true se a URL contém 'color_', false caso contrário
 */
export const isColorUrl = (url) => {
    const key = "@prit/colorBackground";
    const current = sessionStorage.getItem(key);
    if (current) sessionStorage.removeItem(key); 
    if (!url) return false;
    return url.startsWith('color_') || url.includes('color_');
};

/**
 * Extrai o código hexadecimal de cor de uma URL e retorna no formato #RRGGBB.
 * Usado para obter a cor de background a partir da URL (ex: color_6A4C93.svg retorna #6A4C93)
 * @param {string} url - URL contendo o código de cor (ex: .../color_6A4C93.svg)
 * @returns {string|null} - Código hexadecimal no formato #RRGGBB ou null se não encontrado
 */
export const getColorFromUrl = (url) => {
    if (!url) return null;
    const match = url.match(/color_([a-fA-F0-9]{6})/);

    if (match) sessionStorage.setItem("@prit/colorBackground", `#${match[1]}`);

    return match ? `#${match[1]}` : null;
};
export const limitString = (string, limit) => {
    if (!string) return "";
    if (string.length <= limit) return string;
    return string.substring(0, limit) + "...";
}

export const callWithSupport = (message, t) => {
    const supportNumber = process?.env?.REACT_APP_SUPPORT_WHATSAPP || "+5516996500540"; 
    const messageText = message || t("msgSupport");
    const decoded = decodeURIComponent(messageText);
    const link = `https://wa.me/${supportNumber}?text=${encodeURIComponent(decoded)}`;

    window.open(link, "_blank");
}

function hexToRgb (hex) {
    hex = hex.replace('#', '');

    const r = parseInt(hex.substring(0,2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4,6), 16);

    return { r, g, b }
}

function getLuminance(r, g, b) {
    // Normaliza os valores RGB (0-1)
    const [rs, gs, bs] = [r, g, b].map(c => {
        c = c / 255;

        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });

    // Fórmula da luminância relativa
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

export const getContrastColor = (bgColor) => {
    const {r, g, b} = hexToRgb(bgColor);
    const luminance = getLuminance(r , g, b);

    return luminance > 0.5 ? '#333333' : '#FFFFFF'; 
}
